import React from 'react';
import { NetworkHostsTable } from '../network/network-hosts-table';
import { trpc } from '../../api/trpc';
import { useSelector } from '../../store/utils';

type Props = {
  value?: { mac: string; ip: string };
  onChange: (value: { mac: string; ip: string } | undefined) => void;
};

export const InternalNetworkHosts = ({ value, onChange }: Props) => {
  const managedNetwork = useSelector(
    (s) => s.variables.NETWORK_CAPABILITIES.managedNetwork
  );

  const getData = trpc.network.get.useQuery(undefined, {
    refetchInterval: 5000,
    enabled: managedNetwork,
  });

  return (
    <NetworkHostsTable
      variant="select"
      value={value}
      onChange={onChange}
      paperSx={{ p: 0 }}
      getData={getData}
    />
  );
};
